import { type DOMOutputSpec, type NodeSpec } from "prosemirror-model";

export const table_cell: NodeSpec = {
	content: "inline*",
	tableRole: "cell",
	isolating: true,
	parseDOM: [{ tag: "td" }],
	toDOM(): DOMOutputSpec {
		return ["td", 0];
	},
};
